export const removePingWidget = () => {
    let pingpilotWidget = document.getElementById('pingpilot');
    let pingpilotContainer = document.getElementById('pingpilot-master-container');

    if (pingpilotWidget) {
        pingpilotWidget.remove();
    }

    if (pingpilotContainer) {
        pingpilotContainer.remove();
    }
}

export const loadPingWidget = (params) => {
    let newWidget = document.createElement('script');

    newWidget.src = 'https://widget.pingpilot.com';
    for (let prop in params) {
        newWidget.setAttribute(prop, params[prop]);
    }

    document.body.appendChild(newWidget);
}